import { IImageProp } from '@/constants';
import WebAppIcon from '@/images/layout/pc-web.svg';
import MobilePhoneIcon from '@/images/layout/mobile-app.svg';
import ChromeExtensionIcon from '@/images/layout/chrome-extension.svg';
import VideoRecordIcon from '@/images/layout/video-record.svg';
import MinutesIcon from '@/images/layout/public-summary.svg';
import InquiryIcon from '@/images/layout/inquiry-icon.svg';
import LLMSecurityIcon from '@/images/layout/llm-security-icon.svg';
import SecurityIcon from '@/images/layout/security-icon.svg';
import CompanyIcon from '@/images/layout/company-icon.svg';
import ScheduleIcon from '@/images/layout/schedule-icon.svg';
import AISummaryTemplateIcon from '@/images/layout/ai-summary-template.svg';

export interface INavItem {
  title: string;
  icon?: IImageProp;
  link: string;
  hoverBg?: string;
  desc?: string;
}

export interface IDropdownListItem {
  title?: string;
  navItemList: INavItem[];
}

export interface IHeaderNavDropdown {
  type: 'dropdown';
  label: string;
  dropdownList: IDropdownListItem[];
}

export interface IHeaderNavLink {
  type: 'link';
  label: string;
  link: string;
}

export const HEADER_NAV_DATA: (IHeaderNavDropdown | IHeaderNavLink)[] = [
  {
    type: 'dropdown',
    label: 'プロダクト',
    dropdownList: [
      {
        title: 'Nottaについて',
        navItemList: [
          {
            icon: {
              src: CompanyIcon,
              alt: '会社概要',
            },
            title: '会社概要',
            link: '/company',
          },
          {
            icon: {
              src: SecurityIcon,
              alt: 'セキュリティ',
            },
            title: 'セキュリティ',
            link: '/security',
          },
          {
            icon: {
              src: LLMSecurityIcon,
              alt: 'LLMセキュリティ',
            },
            title: 'LLMセキュリティ',
            link: '/llm-security',
          },
          {
            icon: {
              src: InquiryIcon,
              alt: 'お問合せ',
            },
            title: 'お問合せ',
            link: '/inquiry',
          },
        ],
      },
      {
        title: 'プロダクト',
        navItemList: [
          {
            title: 'Web版',
            link: '/web',
            icon: {
              src: WebAppIcon,
              alt: 'Web版',
            },
            desc: 'PCでインストール不要の文字起こしツール',
            hoverBg: '#F1F0FC',
          },
          {
            title: 'アプリ',
            link: '/mobile',
            icon: {
              src: MobilePhoneIcon,
              alt: 'アプリ',
            },
            desc: 'iOS/Androidで使える文字起こしアプリ',
            hoverBg: '#FDF1F7',
          },
          {
            title: 'Chrome拡張機能',
            link: '/chrome-extension',
            icon: {
              src: ChromeExtensionIcon,
              alt: 'Chrome拡張機能',
            },
            desc: '複数のWebページで再生している音声を文字起こし',
            hoverBg: '#FEF9EC',
          },
        ],
      },
      {
        title: '機能一覧',
        navItemList: [
          {
            title: 'スケジュール機能',
            link: '/features/scheduler',
            icon: {
              src: ScheduleIcon,
              alt: 'スケジュール機能',
            },
            desc: '会議の予約から文字起こしの流れがスムーズに',
            hoverBg: '#F1FAFE',
          },
          {
            title: '画面録画',
            link: '/features/screen-recorder',
            icon: {
              src: VideoRecordIcon,
              alt: '画面録画',
            },
            desc: '録画とテキストを生成し、情報の再利用を加速',
            hoverBg: '#F1FAFE',
          },
          {
            title: '議事録',
            link: '/features/minutes',
            icon: {
              src: MinutesIcon,
              alt: '議事録',
            },
            desc: '会話が自動記録し、議事録の作成をサポート',
            hoverBg: '#F1FAFE',
          },
          {
            title: 'AI要約テンプレート',
            link: '/features/ai-templates',
            icon: {
              src: AISummaryTemplateIcon,
              alt: 'AI要約テンプレート',
            },
            desc: 'AIが文字起こしデータを自動的に要約',
            hoverBg: '#F1FAFE',
          },
        ],
      },
    ],
  },
  {
    type: 'link',
    label: '料金プラン',
    link: '/pricing',
  },
  {
    type: 'link',
    label: '法人向け',
    link: '/business',
  },
  {
    type: 'dropdown',
    label: 'お役立ち資料',
    dropdownList: [
      {
        navItemList: [
          {
            title: '資料一覧',
            link: '/resources',
            desc: 'お役に立つ資料や動画をご用意',
          },
          {
            title: 'ブログ',
            link: '/blog',
            desc: '生産力向上の課題解決に繋がる最新DX・AI関連情報をお届け',
          },
          {
            title: 'サポート',
            link: 'https://support.notta.ai/hc/ja',
            desc: '利用方法、不具合の解決策など各種お問い合わせ窓口をご案内',
          },
        ],
      },
    ],
  },
  {
    type: 'link',
    label: '導入事例',
    link: '/cases',
  },
];
